<template>
  <div class="ml-1">
    <b-list-group class="mt-1 group--advance--container" >
      <div v-for="(element, index) in dataLogs" :key="index">
        <template v-if="index === 'creation'">
          <h3 class="mb-1 title--advance-tab">{{element.title}}</h3>
          <div v-if="showItems" >
            <b-list-group-item v-for="item in element.data" :key="item" >        
              <b-row>
                <b-col cols="8" sm="6">
                  <b-badge variant="success" class="badge--advance-tab">{{item}}</b-badge>
                </b-col>
                <b-col cols="4" sm="6">
                  <b-button variant="plain" class="p-0" v-if="!validateUrl(creation[item][0])" :href="replaceRegisterUrl(creation[item][0])" target="_blank" v-b-tooltip.hover title="Ver registro">
                    <icons :icon="'ArchiveIcon'"></icons>
                  </b-button>
                  <span v-if="validateUrl(creation[item][0])">{{creation[item][0]}}</span>
                </b-col>
              </b-row>
            </b-list-group-item>
          </div>
          <div v-if="!showItems" class="text-center py-2">
            <h3>No existen logs para mostrar</h3>
          </div>
        </template>
        <template v-if="index === 'policy'">
          <div v-if="element.data && element.data.length > 0">
          <h3 class="mb-1 title--advance-tab">{{element.title}}</h3> 
            <b-list-group-item v-for="(item, index) in element.data" :key="index">
              <b-container>
                <b-row>
                  <b-col cols="4" >
                    <b-badge variant="success" class="badge--advance-tab">{{ item.label }}</b-badge>
                  </b-col >
                  <b-col cols="4" class="date--advance-tab">
                    {{ item.created_at }}
                  </b-col>
                  <b-col cols="4" class="button--container">
                    <b-button v-for="(button, index) in item.buttons" variant="plain" class="p-0"
                      v-b-tooltip.hover
                      :key="index" 
                      :title="button.title" 
                      @click="button.action">
                      <icons :icon="button.icon"></icons>
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-list-group-item>
          </div>
        </template>
      </div>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icons from '@/Icons/Icons.vue'
import { BContainer, BRow, BCol } from 'bootstrap-vue'

export default {
  name: 'advance',
  props: {
    policyData: { type: Object, default: () => ({}) }
  },
  components: {
    Icons,
    BContainer,
    BRow,
    BCol
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      delivery: 'getDeliveryDetails'
    }),
    creation() {
      return this.delivery?.delivery?.creation ?? {}
    },
    keys() {
      return this.delivery?.delivery?.creation ? Object?.keys(this.delivery?.delivery?.creation) : []
    },
    showItems() {
      return this.keys.length > 0
    },
    dataLogs() {
      return {
        creation: {
          title: 'Logs relevantes de la creación del envío',
          data: [...this.keys]
        },
        policy: {
          title: 'Logs relevantes del seguro Envíame',
          data: this.policyData?.logs && this.policyData?.logs.length > 0 ? this.policyData.logs.map((item) => {
            return {
              ...item,
              label: `policy_${item.process}_log`,
              buttons: [
                {
                  icon: 'BoxIcon',
                  title: 'Ver delivery',
                  action: () => {
                    window.open(item.log_delivery, '_blank')
                  }
                },
                {
                  icon: 'InboxOpen',
                  title: 'Ver request',
                  action: () => {
                    window.open(item.log_request, '_blank')
                  }
                },
                {
                  icon: 'EnvelopePaper',
                  title: 'Ver response',
                  action: () => {
                    window.open(item.log_response, '_blank')
                  }
                }
              ]
            }
          }) : []
        }
      }
    }
  },
  methods: {
    replaceRegisterUrl(item) {
      return item.replace(/storage\.googleapis\.com\/(carrier-deliveries|log-deliveries-santiago)/g, 'storage.cloud.google.com/$1')
    },
    validateUrl(item) {
      return ['Sin'].includes(item.substring(0, 3))
    }
  }
}
</script>
<style lang="scss">
  .group--advance--container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 20px;
    .button--container {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
    .badge--advance-tab,
    .date--advance-tab, 
    .title--advance-tab {
      align-content: center;
      letter-spacing: 0;
      font-family: Montserrat;
      font-size: 12px;
      line-height: 100%;
    }
    .badge--advance-tab {
      height: 29px;
      font-weight: 600;
    }
    .date--advance-tab {
      font-weight: 400;
      color: #444444;
    }
    .title--advance-tab {
      font-weight: 500;
      font-size: 18px;
      color: #5E5873;
    }
  }
</style>